import {
  ItemSetPublishErrorsAlert,
  ItemSetQuestionEditFormActions,
  ItemSetQuestionPreviewButton,
  ItemSetSubQuestionPreview,
} from '@exam-management/qcontent-detail';
import {
  DetailSectionWrapper,
  ItemSetInformationSection,
  ItemSetLocationsPreview,
  ItemSetParagraphSection,
  ItemSetQuestionsInLocationSection,
  ItemSetSubQuestionSection,
  LocationSectionWrapper,
  QuestionLayout,
} from '@exam-management/qcontent-management';
import { Box, Flex, PaperSection } from '@shared/components';

export default function ItemSetDetailPage() {
  return (
    <Box>
      <ItemSetPublishErrorsAlert />
      <QuestionLayout
        sideContent={
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
            <PaperSection title='Location'>
              <LocationSectionWrapper>
                <ItemSetLocationsPreview />
              </LocationSectionWrapper>
            </PaperSection>
            <ItemSetQuestionsInLocationSection />
          </Flex>
        }
      >
        <Flex sx={(theme) => ({ width: '100%', flexDirection: 'column', gap: theme.spacing(6) })}>
          <PaperSection title='Question Details' endAdornment={<ItemSetQuestionPreviewButton />}>
            <DetailSectionWrapper>
              <ItemSetInformationSection />
              <ItemSetParagraphSection />
              <ItemSetSubQuestionSection>
                <ItemSetSubQuestionPreview />
              </ItemSetSubQuestionSection>
            </DetailSectionWrapper>
          </PaperSection>
          <ItemSetQuestionEditFormActions />
        </Flex>
      </QuestionLayout>
    </Box>
  );
}
